module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hublespot table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.hubspot')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.hubspot')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [(_vm.authorized && !_vm.show) ? _c('button', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _vm._e(), (!_vm.authorized && !_vm.show) ? _c('button', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": _vm.connect
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))]) : _vm._e()])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "close-form-button",
      "type": "button",
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "hublespot__carousel"
  }, [_c('span', {
    staticClass: "indice"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.webhooksCapslock')))])])]), _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('div', {
    staticClass: "form-group margin-top",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "hs_url",
      "name": "hs_url",
      "type": "text",
      "readonly": _vm.hs_carousel != null
    },
    domProps: {
      "value": _vm.hs_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-copy",
    attrs: {
      "id": "btn-copy-hs-url"
    },
    on: {
      "click": _vm.copyURLhs
    }
  }, [_vm._v(_vm._s(_vm.copied_hs ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]), _c('hr', {
    staticClass: "lines-div",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }), _c('span', {
    staticClass: "indice"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.receiveContactsTitle')))])])]), _c('span', {
    staticClass: "ind"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.receiveContacts')) + ":")])]), _c('div', {
    staticClass: "checkbox-inline margin-top",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.setting.create_webhook = !_vm.setting.create_webhook
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.setting.create_webhook
    }
  }), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "min-width": "465px",
      "margin-right": "35px",
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.addContacts')) + ":")])]), (_vm.checkedCreateWebhook) ? _c('stages-select', {
    attrs: {
      "integration": "hubspot_integration",
      "filter_item_selected_ids": _vm.metadata_lifecycles
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "item-selected-items": _vm.itemSelectedItems
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "info info-rd",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.smartLeads')))]), _c('span', {
    staticClass: "indice indice-plus"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.contactsDistributionTitle')))])]), _c('div', {
    staticClass: "flow-type-toggler-wrapper"
  }, [_c('div', {
    staticClass: "toggler-inline flow-type-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleUseCarousel()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.setting.use_carousel
    }
  }), _c('label', [_vm._v(_vm._s(_vm.use_carousel()))])])]), (_vm.setting.use_carousel == false) ? _c('div', {
    staticClass: "hublespot__info info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.eachUser')))]), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.eachUserDescription')))])]) : _vm._e()]), (_vm.setting.use_carousel) ? _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('div', {
    staticClass: "hublespot__info info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.carousel')))]), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.carouselDescription')))])])]) : _vm._e(), _c('div', {
    staticClass: "form-group margin-top"
  }, [(_vm.setting.use_carousel) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hs-carousel-modal"
    },
    on: {
      "click": _vm.loadHsCarouselData
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()])]), _c('carousel-modal', {
    ref: "hs_carousel_modal",
    attrs: {
      "id": "hs-carousel-modal",
      "modal-title": _vm.modalTitle(),
      "kind": "hs"
    },
    on: {
      "savedCarousel": _vm.fillHsCarousel
    }
  }), _c('hr', {
    staticClass: "lines-div"
  }), _c('div', {
    staticClass: "hublespot__funil"
  }, [(_vm.show_configuration_by_pipeline_name) ? _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "info info-crm"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.configByPipeline')))])])]) : _vm._e(), (_vm.show_configuration_by_pipeline_name) ? _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('pipeline')
    }
  }, [_c('label', {
    attrs: {
      "for": "pipeline"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelName')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.pipeline),
      expression: "setting.pipeline"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "setting.pipeline",
      "type": "text",
      "placeholder": _vm.$t('integrations.placeholder.funnelName')
    },
    domProps: {
      "value": (_vm.setting.pipeline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.setting, "pipeline", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('stage')
    }
  }, [_c('label', {
    attrs: {
      "for": "stage"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelStage')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.stage),
      expression: "setting.stage"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "setting.stage",
      "type": "text",
      "placeholder": _vm.$t('integrations.placeholder.funnelStage')
    },
    domProps: {
      "value": (_vm.setting.stage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.setting, "stage", $event.target.value)
      }
    }
  })])]) : _vm._e(), _c('span', {
    staticClass: "indice"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.sendContactsTitle')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('trigger-stages', {
    attrs: {
      "integration": "hubspot",
      "settings": _vm.setting.triggers
    },
    on: {
      "selected-stages": _vm.setStages
    }
  })], 1), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.lost_checked || _vm.stage_lost) ? _c('deal-lost', {
    attrs: {
      "settings": _vm.setting.mark_as
    },
    on: {
      "selected": _vm.setMarkAs
    }
  }) : _vm._e()], 1)]), _c('hr', {
    staticClass: "lines-div",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }), _vm._m(1), _c('div', {
    staticClass: "hublespot__info info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.syncContacts')))]), _c('properties-matching', {
    attrs: {
      "properties_matching": _vm.properties_matching,
      "integration_name": "HubSpot",
      "api_fields": _vm.api_fields
    },
    on: {
      "matching-updated": _vm.matchingUpdated
    }
  }), _c('stages-matching', {
    attrs: {
      "stages_matching": _vm.setting.stages_matching,
      "integration_name": "hubspot",
      "integration_stages": _vm.integration_stages,
      "pipelines": _vm.integration_pipelines,
      "pipeline_id": _vm.selected_pipeline
    },
    on: {
      "matching-updated": _vm.matchingStagesUpdated,
      "users-update": _vm.updateUsers,
      "update-stages": _vm.changePipeline
    }
  }), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
    staticClass: "pull-right btn btn-danger btn-nylas",
    on: {
      "click": _vm.disconnect
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/hubspot.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "indiceSyc indice"
  }, [_c('h4', [_c('strong', [_vm._v("Hubspot Sync")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-657d908c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/hubspot.vue
// module id = 1151
// module chunks = 1